import modal from "src/components/ui-components/Modal/ModalContent.module.css";
import cn from "classnames";
import { ModalWithoutTrigger } from "src/components/ui-components/Modal";
import { useEffect, useState } from "react";
import React from "react";
import {
  tryLocalStorageGetItem,
  tryLocalStorageSetItem,
} from "src/utils/storage/storage";
import { withNoSSR } from "src/components/ui-components/withNoSSR/withNoSSR";
import { Button } from "src/components/ui-components/Button/Button";
import { useWindowSize } from "@reach/window-size";
import AmplitudeService from "src/services/amplitude";

interface Props {
  title: string;
  description: React.ReactNode;
  imgSrc: string;
  feature: string; // this will be used as key to store in localStorage
  actions?: React.ReactNode;
  endDate?: Date;
}

export const NewFeatureHighlightGlobal = withNoSSR(function NFHG(props: Props) {
  const { title, feature, endDate = new Date() } = props;
  const [isOpen, setIsOpen] = useState(
    tryLocalStorageGetItem(feature) !== "true"
  );
  const isMobile = useWindowSize().width < 699;
  const isExpired = Date.now() > endDate.valueOf();

  const isHidden = !isOpen || isMobile || isExpired;

  const handleClose = () => {
    tryLocalStorageSetItem(feature, "true");
    AmplitudeService.trackEvent("New Feature Global Highlight Closed", {
      feature,
    });
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isHidden) {
      AmplitudeService.trackEvent("New Feature Global Highlight Viewed", {
        feature,
      });
    }
  }, [isHidden]);

  if (isHidden) {
    return null;
  }

  return (
    <ModalWithoutTrigger
      size="M"
      label={title}
      content={<Content {...props} handleClose={handleClose} />}
      isOpen={isOpen}
      onDismiss={undefined}
    />
  );
});

function Content(props: Props & { handleClose: () => void }) {
  const { title, description, imgSrc, handleClose, actions } = props;

  return (
    <div className={cn(modal.body)}>
      <img src={imgSrc} className={modal.image} />

      <div className={modal.header}>
        <div className={modal.titleRow}>
          <h2>{title}</h2>
        </div>

        <p className={modal.description}>{description}</p>
      </div>

      <div className={modal.buttons}>
        <Button size="M" theme="tertiary" onClick={handleClose}>
          Close
        </Button>

        {actions}
      </div>
    </div>
  );
}
